import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9d148964"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d148964')) {
      api.createRecord('9d148964', component.options)
    } else {
      api.reload('9d148964', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9d148964", function () {
      api.rerender('9d148964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/message/triggerManage/index.vue"
export default component.exports